//https://res-5.cloudinary.com/oitchau/
import React from 'react';
import { ImageField, ImageFieldProps, useRecordContext } from 'react-admin';
import get from 'lodash/get';
import { update } from 'lodash';

export interface PrefixedImageFieldProps extends ImageFieldProps {
  prefix: string;
}

const PrefixedImageField = (props: PrefixedImageFieldProps) => {
  const { prefix, ...rest } = props;
  const record = useRecordContext(props);
  if (!record) {
    return null;
  }
  const v = get(record, props.source!);
  if (v && !v.startsWith(prefix)) {
    update(record, props.source!, (value: any) => `${prefix}/${value}`);
  }
  return <ImageField {...rest} />;
};

export default PrefixedImageField;
